module.exports = __webpack_public_path__ + "245ccff93105761d6a730b8f1bf617f3.svg";